module.exports = __webpack_public_path__ + "static/media/mcaarchitects.32ff0095.png";